import type { IErrorHandlingRequestState } from 'features/errorHandling/errorHandlingSlice';
import { Button, Modal, Text, cnMixSpace, IconClose } from 'uikit';
import { returnsToBreaks } from 'utils/dom';

import cn from 'classnames';
import type React from 'react';

import Styles from './UploadStatus.module.css';

interface IUploadErrorList {
    handleCloseModal: () => void;
    isOpened: boolean;
    data?: IErrorHandlingRequestState | null;
    statusText?: string;
    withTitleCloseButton?: boolean;
    titleText?: string;
    btnText?: string;
    status?: 'success' | 'error';
    style?: React.CSSProperties;
    additionalText?: string;
}

export const UploadStatus: React.FC<IUploadErrorList> = ({
    isOpened,
    data = null,
    handleCloseModal,
    statusText = '',
    withTitleCloseButton = true,
    titleText = '',
    btnText = 'Закрыть',
    children,
    status,
    style,
    additionalText,
}) => {
    const withValidation = !data?.hideValidation && !!data?.validation?.length;

    return (
        <Modal
            isOpen={isOpened}
            className={cn(Styles.root, {
                [Styles.success]: status === 'success',
                [Styles.error]: status === 'error',
            })}
            hasOverlay
            style={style}
        >
            <div
                className={cnMixSpace({
                    pB: 'm',
                })}
            >
                <div className={Styles.title}>
                    <Text as="h3" size="s" view="secondary">
                        {titleText}
                    </Text>
                    {withTitleCloseButton && handleCloseModal && (
                        <Button
                            onClick={handleCloseModal}
                            label={btnText}
                            iconSize="s"
                            iconLeft={IconClose}
                            view="clear"
                            onlyIcon
                        />
                    )}
                </div>
                <div className={Styles.body}>
                    {statusText && (
                        <Text style={{ margin: 0 }} as="p" size="s" view="primary">
                            {statusText}
                        </Text>
                    )}
                    {data?.message && (
                        <Text as="p" size="s" view="primary" style={{ margin: 0 }}>
                            {returnsToBreaks(data?.message || '')
                                ?.split('<br/>')
                                .map((i, id) => <div key={id}>{i}</div>)}
                        </Text>
                    )}

                    {withValidation && (
                        <ul className={Styles.errorList}>
                            {data?.validation?.map((errorItem, idx) => (
                                <li key={idx}>
                                    <Text as="p" size="s" view="primary" className={Styles.errorListItem}>
                                        {returnsToBreaks(errorItem.message)
                                            ?.split('<br/>')
                                            .map((i, id) => <div key={id}>{i}</div>)}
                                    </Text>
                                </li>
                            ))}
                        </ul>
                    )}

                    {additionalText && (
                        <Text as="p" size="s" view="primary" style={{ margin: 0 }}>
                            {additionalText}
                        </Text>
                    )}
                </div>
                <div className={Styles.closeBtnWrapper}>
                    {children || <Button label={btnText} onClick={handleCloseModal} />}
                </div>
            </div>
        </Modal>
    );
};

UploadStatus.displayName = 'UploadStatus';
